import { useMutation } from "@tanstack/react-query";
import { createHelp } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useCreateHelp = () => {
    const { showNotification } = useNotification();

    return useMutation({
        mutationFn: (data) => createHelp(data),
        onSuccess: () => {
            showNotification('success', 'Help request submitted successfully!');
        },
        onError: (error) => {
            console.error("Error creating help request:", error);

            let errorMessage = 'An error occurred while submitting the help request. Please try again.';
            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.response?.data?.error?.message) {
                errorMessage = error.response.data.error.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }

            showNotification('danger', errorMessage);
        },
    });
};
